import { AuditInfo } from './common.model';
import { Feature } from './feature.model';

export interface Pricing {
  monthly: number;
  yearly: number;
  currency: string;
  discount?: number;
  razorpayMonthlyPlanId?: string;
  razorpayYearlyPlanId?: string;
}

export interface PlanFeatureMapping {
  featureId: string;
  featureComparedValue: string | boolean;
  featureName?: string;
  featureType?: string;
}

export interface Plan {
  planId: string;
  planName: string;
  planDescription: string;
  planType: string;
  visibility: boolean;
  pricing: Pricing[];
  mostPopular: boolean;
  planSpecifications?: string;
  sequence: number;
  discount?: number;
  features: Feature[];
  planStatus: 'Active' | 'Draft' | 'Archived';
  auditInfo?: AuditInfo;
  pricingMonthly?: string;
  pricingYearly?: string;
  mappedFeatures?: number;
  minUsers?: number;
  taxDetails?: { taxCode: string; taxPerc: number };
}

export interface PlanRequest {
  planName: string;
  planDescription: string;
  planType: string;
  visibility: boolean;
  minUsers: number;
  pricing: Pick<Pricing, 'monthly' | 'yearly' | 'currency'>[];
  mostPopular: boolean;
  planSpecifications?: string;
  sequence?: number;
  features: PlanFeatureMapping[];
}

export type Duration = 'MONTHLY' | 'YEARLY';

export enum DurationEnum {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY',
}

export interface SavedPricingRow extends Pricing {
  id: string;
  discount: number;
}
